<template>
  <div class="list-wrapper">
    <div class="list-item">
      <el-icon class="list-item-icon" style="background-color: var(--lzd-bg-1)">
        <MobileOutlined />
      </el-icon>
      <div class="list-item-body">
        <ele-text size="md">绑定手机号</ele-text>
        <ele-text type="placeholder" v-if="!user.phone || user.isPhone !== 1">
          当前未绑定手机号
        </ele-text>
        <ele-text type="placeholder" v-else>
          已绑定手机号：
          {{ user.phone?.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') }}
        </ele-text>
      </div>
      <el-link
        type="primary"
        underline="never"
        @click="showBindPhoneVisible = true"
      >
        {{ !user.phone || user.isPhone !== 1 ? '绑定' : '修改' }}
      </el-link>
    </div>
    <el-divider style="margin: 0; opacity: 0.6" />
    <div class="list-item">
      <el-icon class="list-item-icon" style="background-color: var(--lzd-bg-2)">
        <EmailFilled />
      </el-icon>
      <div class="list-item-body">
        <ele-text size="md">绑定邮箱</ele-text>
        <ele-text type="placeholder" v-if="!user.email || user.isEmail !== 1">
          当前未绑定邮箱
        </ele-text>
        <ele-text type="placeholder" v-else>
          已绑定邮箱：{{
            data.email?.replace(/(.+?)(.{4})(.{4})@/, '$1****$2@')
          }}
        </ele-text>
        <ele-text type="placeholder">
          (添加 lun51@lun51.com 到邮箱白名单，避免邮件被拦截)
        </ele-text>
      </div>
      <el-link
        type="primary"
        underline="never"
        @click="showBindEmailVisible = true"
      >
        {{ !user.email || user.isEmail !== 1 ? '绑定' : '修改' }}
      </el-link>
    </div>
    <el-divider style="margin: 0; opacity: 0.6" />
    <div class="list-item">
      <el-icon class="list-item-icon" style="background: #4daf29">
        <WechatFilled />
      </el-icon>
      <div class="list-item-body">
        <ele-text size="md">绑定微信</ele-text>
        <ele-text type="placeholder" v-if="!isWeChat">
          当前未绑定微信，绑定后可使用微信扫码登录
        </ele-text>
        <ele-text type="placeholder" v-else>
          当前已绑定微信，可使用微信扫码登录
        </ele-text>
      </div>
      <el-link
        type="primary"
        underline="never"
        @click="showBindWeChatVisible = true"
      >
        {{ isWeChat ? '修改' : '绑定' }}
      </el-link>
    </div>
    <div v-if="false">
      <el-divider style="margin: 0; opacity: 0.6" />
      <div class="list-item">
        <el-icon
          class="list-item-icon"
          style="background-color: var(--lzd-bg-3)"
        >
          <QqFilled />
        </el-icon>
        <div class="list-item-body">
          <ele-text size="md">绑定QQ</ele-text>
          <ele-text type="placeholder">当前未绑定QQ账号</ele-text>
        </div>
        <el-link type="primary" underline="never">去绑定</el-link>
      </div>
      <el-divider style="margin: 0; opacity: 0.6" />
      <div class="list-item">
        <el-icon class="list-item-icon" style="background: #4daf29">
          <WechatFilled />
        </el-icon>
        <div class="list-item-body">
          <ele-text size="md">绑定微信</ele-text>
          <ele-text type="placeholder">当前未绑定绑定微信账号</ele-text>
        </div>
        <el-link type="primary" underline="never">去绑定</el-link>
      </div>
      <el-divider style="margin: 0; opacity: 0.6" />
      <div class="list-item">
        <el-icon class="list-item-icon" style="background: #1476fe">
          <AlipayFilled />
        </el-icon>
        <div class="list-item-body">
          <ele-text size="md">绑定支付宝</ele-text>
          <ele-text type="placeholder">当前未绑定绑定支付宝账号</ele-text>
        </div>
        <el-link type="primary" underline="never">去绑定</el-link>
      </div>
    </div>

    <!-- 发送短信验证码 -->
    <ele-modal
      form
      :width="348"
      :close-on-click-modal="false"
      v-model="showBindPhoneVisible"
      title="绑定手机号"
    >
      <div style="display: flex; margin-bottom: 12px">
        <div style="flex: 1">
          <el-input
            type="number"
            clearable
            v-model="bindPhoneForm.phone"
            @blur="blurPhone"
            placeholder="请输入手机号"
          />
        </div>
      </div>
      <div style="display: flex; margin-bottom: 22px">
        <div style="flex: 1">
          <el-input
            type="number"
            clearable
            v-model="bindPhoneForm.captchaCode"
            placeholder="请输入验证码"
          />
        </div>
        <div style="margin-left: 12px; width: 100px">
          <el-button
            :id="'bind-phone-btn-code-' + elPhoneId"
            type="primary"
            plain
            :disabled="sendBindPhoneVisible"
            style="width: 100%"
            >{{ sendBindPhoneTips }}</el-button
          >
          <div :id="'bind-phone-element-' + elPhoneId"></div>
        </div>
      </div>
      <div style="display: flex; margin-bottom: 15px">
        <el-button type="primary" style="flex: 1" @click="bindPhone">
          提交绑定
        </el-button>
      </div>
    </ele-modal>

    <!-- 发送邮件验证码 -->
    <ele-modal
      form
      :width="348"
      :close-on-click-modal="false"
      v-model="showBindEmailVisible"
      title="绑定邮箱号"
    >
      <div style="display: flex; margin-bottom: 12px">
        <div style="flex: 1">
          <el-input
            type="email"
            clearable
            v-model="bindEmailForm.email"
            @blur="blurEmail"
            placeholder="请输入邮箱"
          />
        </div>
      </div>
      <div style="display: flex; margin-bottom: 22px">
        <div style="flex: 1">
          <el-input
            type="number"
            clearable
            v-model="bindEmailForm.captchaCode"
            placeholder="请输入验证码"
          />
        </div>
        <div style="margin-left: 12px; width: 100px">
          <el-button
            :id="'bind-email-btn-code-' + elEmailId"
            type="primary"
            plain
            :disabled="sendBindEmailVisible"
            style="width: 100%"
          >
            {{ sendBindEmailTips }}
          </el-button>
          <div :id="'bind-email-element-' + elEmailId"></div>
        </div>
      </div>
      <div style="display: flex; margin-bottom: 15px">
        <el-button type="primary" style="flex: 1" @click="bindEmail">
          提交绑定
        </el-button>
      </div>
    </ele-modal>

    <!-- 绑定微信 -->
    <ele-modal
      form
      :width="348"
      :close-on-click-modal="false"
      v-model="showBindWeChatVisible"
      title="微信扫码绑定"
    >
      <div>
        <ele-qr-code-svg
          :size="304"
          :margin="2"
          :value="qrcode"
          class="login-qrcode"
        />
      </div>
      <div
        style="margin-bottom: 16px; cursor: pointer; text-align: center"
        @click="refreshQrCode"
      >
        <el-icon :size="15" style="vertical-align: -2px; margin-right: 6px">
          <ReloadOutlined />
        </el-icon>
        <span>{{ t('login.refreshQrcode') }}</span>
      </div>
    </ele-modal>
  </div>
</template>

<script lang="ts" setup>
  import { ref, reactive, computed, onUnmounted, watch } from 'vue';
  import { useI18n } from 'vue-i18n';
  import {
    QqFilled,
    WechatFilled,
    AlipayFilled,
    MobileOutlined,
    EmailFilled,
    ReloadOutlined
  } from '@/components/icons';
  import request from '@/utils/request';
  import type { TenantUser, UserSocial } from '@/api/bsl/tenant/user/model';
  import {
    sendEmailCaptcha,
    sendSmsCaptcha,
    showLzdAliyunCaptcha
  } from '@/utils/captcha-utils';
  import { tipsError, tipsSuccess, tipsWarning } from '@/utils/lzd-util';
  import { uuid } from 'ele-admin-plus';
  import { authBindEmail, authBindPhone } from '@/api/bsl/tenant/user';

  const { t } = useI18n();

  const props = defineProps<{
    data: TenantUser;
  }>();
  const emit = defineEmits<{
    (e: 'done', value: TenantUser): void;
  }>();

  const user = ref<Partial<TenantUser>>({
    ...props.data
  });

  // 是否绑定微信
  const isWeChat = computed(() => {
    const socials = user.value.socials || [];
    return socials.findIndex((d) => d.socialType === 'WeChat') > -1;
  });

  // const userSocials = (user.value.socials = user.value.socials || []);

  // 绑定电话 S
  const showBindPhoneVisible = ref(false);
  const bindPhoneFormInit = {
    phone: '',
    captchaToken: '',
    captchaCode: ''
  };
  const bindPhoneForm = reactive({ ...bindPhoneFormInit });

  const sendBindPhoneVisible = ref(true);
  const sendBindPhoneTips = ref('获取验证码');
  const elPhoneId = ref(uuid(8));
  const bindPhone = () => {
    if (!/^1[3-9][0-9]{9}$/.test(bindPhoneForm.phone)) {
      return tipsWarning({
        message: '手机号错误或格式不支持',
        messageEn: 'Incorrect phone number or unsupported format',
        messageTw: '手機號碼錯誤或格式不支持'
      });
    }
    if (!/^[0-9]{6}$/.test(bindPhoneForm.captchaCode)) {
      return tipsWarning({
        message: '验证码输入错误',
        messageEn: 'Incorrect verification code input',
        messageTw: '驗證碼輸入錯誤'
      });
    }
    authBindPhone(
      bindPhoneForm.phone,
      bindPhoneForm.captchaToken,
      bindPhoneForm.captchaCode
    )
      .then((data) => {
        tipsSuccess(data);
        showBindPhoneVisible.value = false;
        user.value.phone = bindPhoneForm.phone;
        user.value.isPhone = 1;
        emit('done', user.value as any);
      })
      .catch((data) => tipsError(data));
  };
  const blurPhone = () => {
    if (!sendBindPhoneVisible.value || !bindPhoneForm.phone) {
      return;
    }
    sendBindPhoneVisible.value = true;
    if (!/^1[3-9][0-9]{9}$/.test(bindPhoneForm.phone)) {
      return tipsWarning({
        message: '手机号错误或格式不支持',
        messageEn: 'Incorrect phone number or unsupported format',
        messageTw: '手機號碼錯誤或格式不支持'
      });
    }
    sendBindPhoneVisible.value = false;
  };

  watch(showBindPhoneVisible, (show) => {
    if (show) {
      // 必须删除相关元素，否则再次mount多次调用 initAliyunCaptcha 会导致多次回调 captchaVerifyCallback
      document.getElementById('aliyunCaptcha-mask')?.remove();
      document.getElementById('aliyunCaptcha-window-popup')?.remove();
      showLzdAliyunCaptcha(
        '#bind-phone-btn-code-' + elPhoneId.value,
        '#bind-phone-element-' + elPhoneId.value,
        (_instance: any) => {},
        async (captchaVerifyParam: string) => {
          const data = await sendSmsCaptcha(
            captchaVerifyParam,
            props.data.tenantId!,
            bindPhoneForm.phone
          ).catch((err) => tipsError(err));
          // 2.构造标准返回参数
          const verifyResult = {
            captchaResult: false, // result.captchaVerifyResult, // 验证码验证是否通过，boolean类型，必选
            bizResult: false // 从result获取您的业务验证结果, // 业务验证是否通过，boolean类型，可选；若为无业务验证结果的场景，bizResult可以为空
          };
          if (typeof data !== 'object') {
            return verifyResult;
          }
          if (data.code === 0) {
            bindPhoneForm.captchaToken = data.data!;
            verifyResult.bizResult = verifyResult.captchaResult = true;
          } else {
            tipsError(data);
          }
          return verifyResult;
        },
        (bizResult: boolean) => {
          if (bizResult) {
            sendBindPhoneVisible.value = true;

            const countdown = (second: number = 120) => {
              sendBindPhoneTips.value = `${second}S 后获取`;
              if (second > 1) {
                setTimeout(() => countdown(second - 1), 1000);
              } else {
                sendBindPhoneTips.value = `获取验证码`;
                sendBindPhoneVisible.value = false;
              }
            };

            countdown(120);
          }
        }
      );
      setTimeout(() => {
        document
          .getElementById('#bind-phone-btn-code-' + elPhoneId.value)
          ?.click();
      }, 150);
    } else {
      Object.assign(bindPhoneForm, bindPhoneFormInit);
    }
  });
  // 绑定电话 E

  // 绑定邮箱 S
  const showBindEmailVisible = ref(false);
  const bindEmailFormInit = {
    email: '',
    captchaToken: '',
    captchaCode: ''
  };
  const bindEmailForm = reactive({ ...bindEmailFormInit });
  const sendBindEmailVisible = ref(true);
  const sendBindEmailTips = ref('获取验证码');
  const elEmailId = ref(uuid(8));
  const bindEmail = () => {
    if (!/^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+$/.test(bindEmailForm.email)) {
      return tipsWarning({
        message: '邮箱号错误或格式不支持',
        messageEn: 'Email address is incorrect or format is not supported',
        messageTw: '郵箱號錯誤或格式不支持'
      });
    }
    if (!/^[0-9]{6}$/.test(bindEmailForm.captchaCode)) {
      return tipsWarning({
        message: '验证码输入错误',
        messageEn: 'Incorrect verification code input',
        messageTw: '驗證碼輸入錯誤'
      });
    }
    authBindEmail(
      bindEmailForm.email,
      bindEmailForm.captchaToken,
      bindEmailForm.captchaCode
    )
      .then((data) => {
        tipsSuccess(data);
        showBindEmailVisible.value = false;
        user.value.email = bindEmailForm.email;
        user.value.isEmail = 1;
        emit('done', user.value as UserSocial);
      })
      .catch((data) => tipsError(data));
  };
  const blurEmail = () => {
    if (!sendBindEmailVisible.value || !bindEmailForm.email) {
      return;
    }
    sendBindEmailVisible.value = true;
    if (!/^[A-Za-z0-9+_.-]+@[A-Za-z0-9.-]+$/.test(bindEmailForm.email)) {
      return tipsWarning({
        message: '邮箱号错误或格式不支持',
        messageEn: 'Email address is incorrect or format is not supported',
        messageTw: '郵箱號錯誤或格式不支持'
      });
    }
    sendBindEmailVisible.value = false;
  };
  watch(showBindEmailVisible, (show) => {
    if (show) {
      // 必须删除相关元素，否则再次mount多次调用 initAliyunCaptcha 会导致多次回调 captchaVerifyCallback
      document.getElementById('aliyunCaptcha-mask')?.remove();
      document.getElementById('aliyunCaptcha-window-popup')?.remove();
      showLzdAliyunCaptcha(
        '#bind-email-btn-code-' + elEmailId.value,
        '#bind-email-element-' + elEmailId.value,
        (_instance: any) => {},
        async (captchaVerifyParam: string) => {
          const data = await sendEmailCaptcha(
            captchaVerifyParam,
            props.data.tenantId!,
            bindEmailForm.email
          ).catch((err) => tipsError(err));
          // 2.构造标准返回参数
          const verifyResult = {
            captchaResult: false, // result.captchaVerifyResult, // 验证码验证是否通过，boolean类型，必选
            bizResult: false // 从result获取您的业务验证结果, // 业务验证是否通过，boolean类型，可选；若为无业务验证结果的场景，bizResult可以为空
          };
          if (typeof data !== 'object') {
            return verifyResult;
          }
          if (data.code === 0) {
            bindEmailForm.captchaToken = data.data!;
            verifyResult.bizResult = verifyResult.captchaResult = true;
          } else {
            tipsError(data);
          }
          return verifyResult;
        },
        (bizResult: boolean) => {
          if (bizResult) {
            sendBindEmailVisible.value = true;

            const countdown = (second: number = 120) => {
              sendBindEmailTips.value = `${second}S 后获取`;
              if (second > 1) {
                setTimeout(() => countdown(second - 1), 1000);
              } else {
                sendBindEmailTips.value = `获取验证码`;
                sendBindEmailVisible.value = false;
              }
            };

            countdown(120);
          }
        }
      );
      setTimeout(() => {
        document
          .getElementById('#bind-email-btn-code-' + elEmailId.value)
          ?.click();
      }, 150);
    } else {
      Object.assign(bindEmailForm, bindEmailFormInit);
    }
  });
  // 绑定邮箱 E

  // 绑定微信
  const showBindWeChatVisible = ref(false);
  /** 二维码 */
  const qrcode = ref('');
  let timeoutId: NodeJS.Timeout | null = null;
  /** 刷新二维码 */
  const refreshQrCode = async () => {
    // 定时
    timeoutId && globalThis.clearTimeout(timeoutId);

    const { token, state } = (
      await request.post('/bsl/tenant/auth/wechat/bind/token')
    ).data.data;

    // 推送 微信扫码记录标识
    const qrFormData = new FormData();
    qrFormData.append('token', token);
    qrFormData.append('state', state);
    // 扫码成功回调地址 POST（异步调用，推送用户信息）
    qrFormData.append(
      'callbackUrl',
      'https://projex.lun51.vip/api/bsl/tenant/auth/wechat/qr/bind/callback'
    );
    // 推送
    await request.post(
      `https://www.lun51.com/apis/weixin/mp/other/qr/record`,
      qrFormData
    );
    // 跳转扫码
    const redirectUrl = encodeURIComponent(
      `https://www.lun51.com/apis/weixin/mp/other/qr/callback/${token}`
    );
    const authorizeUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx0106f0a4d1672215&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=${state}&connect_redirect=1&forcePopup=false&forceSnapShot=false&stylelite=1#wechat_redirect`;

    const formData = new FormData();
    formData.append('url', authorizeUrl);
    const link = (
      await request.post('https://www.lun51.com/link/build', formData)
    ).data as string;
    qrcode.value = link;

    // 获取扫码结果
    function checkBindWechat() {
      timeoutId && globalThis.clearTimeout(timeoutId);
      request
        .get(
          `https://projex.lun51.vip/api/bsl/tenant/auth/wechat/bind/check/${token}/${state}`
        )
        .then((res) => {
          console.log(res);
          if (res.data.code === 0) {
            showBindWeChatVisible.value = false;
            tipsSuccess(res.data);
            const socials = user.value.socials || [];
            const social: UserSocial = {
              userSeq: user.value.seq,
              socialType: 'WeChat',
              socialOpenid: res.data.data
            } as any;
            if (socials.length == 0) {
              socials.push(social);
            } else {
              const weChatIndex = socials.findIndex(
                (d) => d.socialType === 'WeChat'
              );
              if (weChatIndex > -1) {
                socials[weChatIndex] = social;
              } else {
                socials.push(social);
              }
            }
            user.value.socials = socials;
            emit('done', user.value as any);
          } else {
            timeoutId = setTimeout(() => {
              checkBindWechat();
            }, 1000 * 2);
          }
        });
    }

    timeoutId = setTimeout(() => {
      checkBindWechat();
    }, 1000 * 5);
  };
  watch(showBindWeChatVisible, (show) => {
    timeoutId && globalThis.clearTimeout(timeoutId);
    if (show) {
      refreshQrCode();
    }
  });

  onUnmounted(() => {
    // 必须删除相关元素，否则再次mount多次调用 initAliyunCaptcha 会导致多次回调 captchaVerifyCallback
    document.getElementById('aliyunCaptcha-mask')?.remove();
    document.getElementById('aliyunCaptcha-window-popup')?.remove();
    timeoutId && globalThis.clearTimeout(timeoutId);
  });
</script>

<style lang="scss" scoped>
  .list-wrapper {
    padding: 6px 14px;
    box-sizing: border-box;

    .list-item {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 12px 10px;

      .list-item-body {
        flex: 1;

        .ele-text + .ele-text {
          margin-top: 2px;
        }
      }

      .list-item-icon {
        color: #fff;
        padding: 6px;
        font-size: 24px;
        border-radius: 50%;
        background: #3492ed;
        margin-right: 12px;
      }
    }
  }

  /* 二维码 */
  .login-qrcode-group {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .login-qrcode {
    font-size: 0;
    display: inline-block;
    border: 1px solid #ddd;
    border-radius: var(--el-border-radius-base);
    overflow: hidden;
  }
</style>
